import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.object.assign.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import Logger from 'js-logger';
import { make } from 'vuex-pathify';

var defaultState = function defaultState() {
  return {
    apiInProgress: false,
    authUser: {
      isAdmin: true
    },
    automaticUpdates: null,
    defaultTemplate: null,
    hasConnectivity: false,
    language: 'en-gb',
    loggedInMember: null,
    showSettingsSection: false,
    passcode: null,
    selectedTemplate: null,
    setupComplete: false,
    updateWhenOnline: false // Check for updates when app comes back online

  };
};

var state = defaultState();

var actions = _objectSpread(_objectSpread({}, make.actions(state)), {}, {
  // Make default actions

  /**
   * Reset all modules back to their default sate.
   *
   * @param {Object} context Vuex module context
   *
   * @returns {Void}
   */
  resetAllModuleStates: function resetAllModuleStates(_ref) {
    var commit = _ref.commit,
        rootState = _ref.rootState,
        state = _ref.state;
    // Save the connectivity state
    var connectivity = state.hasConnectivity; // Save the UUID (may not be required when out of dev)

    var uuid = rootState.config.uuid; // Reset the state of all modules

    Logger.debug('Reset stored data');
    var modules = Object.keys(rootState); // Build an array of store modules

    modules.forEach(function (module) {
      commit("".concat(module, "/resetState"), null, {
        root: true
      });
    }); // Restore the connectivity state

    commit('hasConnectivity', connectivity); // Restore the UUID (may not be required when out of dev)

    commit('config/uuid', uuid, {
      root: true
    });
  }
});

var getters = _objectSpread({}, make.getters(state));

var mutations = _objectSpread(_objectSpread({}, make.mutations(state)), {}, {
  // Make default mutations

  /**
   * Reset the module state back to its default.
   *
   * @param {Object} state Vuex module state
   *
   * @returns {Void}
   */
  resetState: function resetState(state) {
    Object.assign(state, defaultState());
  }
});

export default {
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations,
  namespaced: true
};